module.exports = __webpack_public_path__ + "img/img_nav_lang-w.df5cdc38.svg";